var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g({attrs:{"color":_vm.statusColor,"text-color":_vm.statusColor === '' ? 'black' : 'white',"small":_vm.small}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.statusText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }